import { useSpaceSummary } from 'atoms/spaces';
import { useUserProfile } from 'atoms/user-profile';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureFlagClient } from 'utils/feature-flags';
import { setFlagsmith } from '@cocoplatform/coco-rtc-client';

export const useFlagTraitEffect = () => {
  const posthog = useFeatureFlagClient();
  const location = useLocation();
  const { userProfile } = useUserProfile();
  const corridorRegex = /\/app\/dashboard\/([A-za-z0-9-$]+)/;
  const corridorId = location.pathname.match(corridorRegex)?.[1] || '';

  const spaceRegex = /\/app\/spaces\/([A-za-z0-9-$]+)/;
  const spaceId = location.pathname.match(spaceRegex)?.[1] || '';

  const { space } = useSpaceSummary({ spaceId });

  useEffect(() => {
    if (posthog) {
      setFlagsmith(posthog);
    }
  }, [posthog]);

  useEffect(() => {
    const hasContext = Boolean(corridorId || (spaceId && space));
    if (!posthog || !userProfile?.id || !hasContext) {
      return;
    }

    const roles = userProfile.instanceRoles || [];
    const isPrimary = roles.includes('PRIMARY_COMMUNITY_BUILDER');
    const isSecondary = roles.includes('SECONDARY_COMMUNITY_BUILDER');

    let instanceRole = '';
    if (isPrimary) {
      instanceRole = 'PRIMARY_COMMUNITY_BUILDER';
    } else if (isSecondary) {
      instanceRole = 'SECONDARY_COMMUNITY_BUILDER';
    }

    const properties = {
      userId: userProfile.id,
      instanceRole,
      communityId: corridorId || space?.communityId || '',
      spaceId,
      domain: window.location.hostname,
    };

    posthog.identify(userProfile.id, properties);
    // posthog.reloadFeatureFlags();
  }, [
    posthog,
    userProfile?.id,
    userProfile?.instanceRoles,
    corridorId,
    spaceId,
    space,
  ]);
};
